import { InteractionType } from "@azure/msal-browser";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import './app.scss';

import Authed from './authed';

const Init = () => {
  useMsalAuthentication(InteractionType.Redirect);
  return <></>;
}

export default function App() {
  return (<>
    <AuthenticatedTemplate>
      <Authed />
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <Init />
    </UnauthenticatedTemplate>
  </>
  );
}
